export default [
  {
    type: "title",
    title: "MPai数据科学平台协议",
    subTitle: "更新日期：2020年8月6日  生效日期：2020年8月6日"
  },
  { type: "divers" },
  {
    type: "context",
    context:
      "欢迎使用广州万灵数据科技有限公司(以下简称“万灵数据”或“我们”)为您提供的MPai数据科学平台（以下简称为“MPai”）软件或服务。请您（下列简称为“用户”）仔细阅读以下全部内容（特别是粗体下划线标注的内容）。如用户未满18周岁，或存在其他不具备与用户行为相适应的民事行为能力的情形，请用户在监护人的陪同下阅读本条款，并确保监护人同意其所有行为，在此情况下，用户及用户的监护人应依照法律规定承担因此而导致的一切后果。如用户对本条款的任何内容表示异议，或者无法准确理解本条款，请不要注册、登录MPai或使用MPai服务。如用户使用MPai软件或服务，即表示用户与万灵数据已达成协议，自愿接受本条款所有内容。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "本条款如由于MPai发展需要修订的，万灵数据将在MPai平台公布。用户可前往查阅最新版协议条款。在万灵数据修改上述条款后，如果用户不接受修改后的条款，用户可以选择终止使用MPai软件或服务。用户继续使用的，将被视为已接受了修改后的条款。"
  },
  {
    type: "titleAndcontext",
    title: "1.账号管理规则",
    subTitle:
      "1.1用户通过登录MPai可以享受MPai的服务。用户登录账号可以是用户本人的手机号或MPai增加的其他可登录的账号。如果用户通过第三方账号登录MPai的，其登录和使用行为同样适用本条款。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "1.2用户使用的MPai登录账号是万灵数据确认用户身份的唯一依据，用户应维持账号及密码的机密安全，并对该账号进行的所有活动和行为负责，禁止赠与、借用、租用、转让或售卖账号。如果用户未保管好自己的帐号和密码而对用户、万灵数据或第三方造成损害，用户将负全部责任。用户同意若发现任何非法使用用户帐号或安全漏洞的情况，有义务立即通告万灵数据。如万灵数据发现或者有合理理由认为账号使用者并非该帐号初始注册人，为保障帐号安全，万灵数据有权立即暂停或终止为该帐号提供服务，并有权封禁或注销、回收该帐号，由此带来的损失由该账号使用人、注册人自行承担。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "1.3用户应在MPai注册账号。用户不得恶意注册帐号（包括但不限于频繁注册、批量注册、使用他人身份注册、恶意利用或破MPai注册系统注册账号等）。任何通过非MPai官方途径获得的账号（包括但不限于购买、借用、租用、分享等方式获得的账号），或恶意注册获得的账号，万灵数据有权进行封禁、注销或回收，如发生任何损失的，用户自行承担全部责任。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "1.4为符合相关法律法规的要求，保障用户的账号安全，万灵数据可能会对用户的身份进行验证，包括但不限于要求输入验证码、手机号认证、邮箱认证等。如用户无法完成验证或拒绝验证的，万灵数据可合理怀疑用户的账号存在安全风险，暂停向用户提供部分或全部服务，并有权采取进一步措施。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "1.5在法律法规允许的范围内，用户同意MPai账号所有权，以及与注册、使用MPai帐号相关的服务数据和记录，包括但不限于所有注册、登录、消费记录和相关的使用统计数据，归万灵数据所有。发生争议时，用户同意以万灵数据的系统数据为准，万灵数据应保证该数据的真实性。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "1.6用户在使用MPai服务时填写、登录、使用的帐号名称、头像等帐号信息资料应遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线，不得在帐号信息资料中出现违法和不良信息，不得冒用、关联机构或社会名人或采取其他足以让人引起混淆的方式注册账号。且用户保证在填写、登录、使用帐号信息资料时，不得有以下情形："
  },
  {
    type: "context",
    context:
      "（1）反对宪法所确定的基本原则的；<br/>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br/>（3）损害国家荣誉和利益的；<br/>（4）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；<br/>（5）宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的；<br/>（6）煽动民族仇恨、民族歧视，破坏民族团结的；<br/>（7）破坏国家宗教政策，宣扬邪教和封建迷信的；<br/>（8）散布谣言，扰乱经济秩序和社会秩序的；<br/>（9）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br/>（10）侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的；<br/>（11）含有法律、行政法规禁止的其他内容的。"
  },
  {
    type: "titleAndcontext",
    context:
      "1.7若用户在注册和使用MPai账号时，存在任何违反法律法规或不符合本条款规定之行为，MPai有权不予注册；已经注册的，万灵数据有权不通知用户而单方采取限期改正、短期封禁、永久封禁、注销、收回账号等措施，并有权向政府主管部门进行报告。"
  },
  {
    type: "titleAndcontext",
    title: "2.服务的变更和中止",
    context:
      "万灵数据始终在不断变更和改进服务。万灵数据根据自身商业决策、政府行为、不可抗力等原因可能会选择中止、中断及终止MPai的部分或全部服务。如有此等情形发生，万灵数据会采取公告的形式通知用户，但不承担由此对用户造成的任何损失。除法律法规另有明确规定的情形外，MPai有权不经用户申请，直接向用户退还尚未履行的服务所对应的费用。"
  },
  {
    type: "titleAndcontext",
    title: "3.用户隐私制度",
    context:
      "尊重用户隐私是万灵数据的一项基本政策。万灵数据将按照《MPai数据科学平台隐私政策》（https://www.mpaidata.com/privacy）收集、存储、使用、披露和保护用户的个人信息。请用户完整阅读上述隐私政策，以帮助用户更好地保护个人信息。"
  },
  {
    type: "titleAndcontext",
    title: "4.用户管理",
    subTitle: "4.1 用户不得利用MPai软件或服务实施以下行为：",
    context:
      "（1）通过非万灵开发、授权或认可的第三方兼容软件、系统登录或使用MPai软件或服务，或针对MPai软件和相关服务使用非万灵数据开发、授权或认证的插件；<br/>（2）删除MPai软件及其他副本上所有关于版权的信息、内容；<br/>（3）对MPai软件进行反向工程、反向汇编、反向编译或以其他方式自MPai软件获取源代码等；<br/>（4）对于MPai软件相关信息等，未经万灵数据同意，擅自实施包括但不限于下列行为：使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助MPai软件发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；<br/>（5）对使用MPai软件或服务过程中释放到任何计算机内存中的数据及软件运行过程中客户端与服务器端的交互数据进行复制、更改、修改；<br/>（6）通过不正当手段或以违反诚实信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用会员身份、黑色产业、投机等违背MPai提供服务的初衷的方式）使用MPai软件和服务；<br/>（7）滥用MPai软件或服务，包括但不限于利用MPai软件或服务进行侵害他人知识产权或者合法利益；<br/>（8）其他以任何不合法的方式、为任何不合法的目的、或以任何与本条款不一致的方式使用MPai软件和服务。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "4.2 用户应遵守万灵数据的所有其他规定和程序。用户须对自己在使用MPai软件或服务过程中的行为承担法律责任。用户理解并同意，若用户违反以上任何规定，万灵数据有权作出独立判断立即暂停或终止对用户提供部分或全部服务，包括封禁用户账号、注销用户账号等措施，用户应自行承担自身损失以及一切相应法律责任。用户承担法律责任的形式包括但不限于：对受到侵害者进行赔偿，以及在万灵数据首先承担了因用户的行为导致的行政处罚或侵权损害赔偿责任后，用户应给予万灵数据等额的赔偿。"
  },
  {
    type: "titleAndcontext",
    title: "5.通知",
    context:
      "所有发给用户的通知都可以通过电子邮件、常规的信件、短信、或在MPai软件或官网内显著位置公告的方式进行传送。万灵数据将通过上述方法之一将消息传递给用户，告知他们服务条款的修改、变更、或其他重要事情。"
  },
  {
    type: "titleAndcontext",
    title: "6.法律",
    context:
      "如果本协议的某一条款或某一条款的一部分无效或不可执行，不影响本协议其他条款的有效性，无效或不可执行的条款将被视作已从本协议中删除。"
  },
  {
    type: "context",
    context:
      "本协议受中华人民共和国法律管辖。 在执行本协议过程中如发生纠纷，双方应及时协商解决。协商不成时，任何一方均应向万灵数据注册地人民法院提起诉讼。"
  },
  {
    type: "titleAndcontext",
    title: "7.其他",
    context:
      "用户可以通过本条款文末列明的客服邮箱投诉、举报各类违法违规行为，万灵数据将及时受理和处理用户的投诉举报。"
  },
  {
    type: "context",
    context:
      "万灵数据存储在其服务器上的数据是用户使用MPai软件或服务的唯一有效证据。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "本条款自发布之日起实施，并构成用户和万灵数据之间的共识。万灵数据不行使、未能及时行使或者未充分行使本条款或者按照法律规定所享有的权力，不应被视为放弃该权利，也不影响万灵数据在将来行使该权利。基于法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会向有权机关披露您的个人信息。但我们保证，在上述情况发生时，我们会要求披露请求方必须出具与之相应的有效法律文件，并对被披露的信息采取符合法律和业界标准的安全防护措施。"
  },
  {
    type: "titleAndcontext",
    subTitle:
      "如果用户对本条款内容有任何疑问，请发送邮件至我们的客服邮箱：mpai@willingdata.com."
  }
];
